import MediaServiceCache from './MediaServiceCache';
import MediaServiceAPI from './MediaServiceAPI';
import Match from '@core/models/offer/Match';

export default class MediaService {
    constructor(
        private mediaServiceAPI = new MediaServiceAPI(),
        private mediaServiceCache = new MediaServiceCache()) {}

    public async getMatchVideoStream(match: Match) {
        if (this.mediaServiceCache.hasVideoStreamForMatch(match.id)) {
            return this.mediaServiceCache.getVideoStreamForMatch(match.id);
        }
        try {
            const data = await this.mediaServiceAPI.getMatchVideoStream(match.streamInfo);
            this.mediaServiceCache.storeVideoStreamForMatch(match.id, data!);
            return data;
        } catch (e) {
            throw e;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/media/MediaService.ts